<template>
    <el-dialog
            title="设置明细表单"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="160px">
            <el-form-item label="明细表单" prop="detailFormId">
                <el-select
                        v-model="dataForm.detailFormId"
                        placeholder="明细表单"
                        style="display: block; margin-bottom: 10px"
                >
                    <el-option
                            v-for="item in detailFormList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="表达式" prop="expression">
                <el-input v-model="dataForm.expression" placeholder="表达式"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    const datasetValue = {
        id: '',
        formId: '',
        detailFormId: '',
        expression: '',
        sort: 10,
    };
    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                visible: false,
                dataForm: datasetValue,
                detailFormList: [],
                dataRule: {
                    detailFormId: [
                        {required: true, message: '明细表单不能为空', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            init(formId, id) {
                this.dataForm.id = id || ''
                this.dataForm.formId = formId || ''
                this.visible = true
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                this.$http
                    .post("/customform/list", {
                        page: 1,
                        rows: 1000,
                        filter: {
                            formType: 1
                        },
                    },{baseURL:  process.env.VUE_APP_proxybaseurl + '',})
                    .then(({data}) => {
                        if (data) {
                            this.detailFormList = data.rows;
                        } else {
                            this.detailFormList = [];
                        }
                    });
            },
            // 表单提交
            dataFormSubmit() {
                this.$httpReq({
                    url: '/customform/addShip',
                    method: 'post',
                    baseURL:  process.env.VUE_APP_proxybaseurl + '',
                    data: this.dataForm
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
